import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {repeat} from 'lit/directives/repeat.js';

import {connect} from 'pwa-helpers';
import next from '../../../icons/next';
import store from '../../store';

import {
	selectBasicSpcAttributes, selectBasicSpcAttributesSatisfactionPercentage, selectBasicSpcAttributesSatisfied, selectDetailSpcAttributes,
	selectDetailSpcAttributesSatisfactionPercentage,
	selectDetailSpcAttributesSatisfied, selectFamily, selectFamilyConfig, selectSpcConfiguration, selectSpcIsSatisfied, selectSpcSession
} from '../../selectors';

@customElement('download-button')
export class DownloadButton extends connect(store)(LitElement) {

	static styles = css`
		:host {
			width: 100%;
		}


		button {
			height: 100%;
			text-align: left;
			font: var(--font-widget-label);
			color: var(--fix-color-white);
			background-color: var(--fix-color-button-back);
			padding: 0;

			display: flex;
			flex-direction: column;
			position: relative;
			justify-content: space-between;
			margin-bottom: 0;
			border: 1px solid var(--fix-color-border);
			cursor: pointer;
			width: 100%;
			transform-origin: center;
			transition: background-color 0.4s ease-out, color 0.4s ease-out;
			&:hover {
				background-color: var(--fix-color-button-back-hover);
			}
		}
		.buttonLabel {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			gap: var(--padding);
			align-items: center;
			border-bottom: 1px solid var(--fix-color-border);
		}
		.infos {
			padding: var(--very-small-padding);
			color: var(--fix-color-white);
			flex-grow: 1;
		}
		@media (max-width: 1024px) {
			.infos {
				display: none;
			}

			.buttonLabel {
				border-bottom: none;
			}
		}

		.info:last-child {
			font-weight: bold;
		}

		.label {
			font: var(--font-widget-big-label);
			padding: var(--very-small-padding);
			z-index: 2;
			color: var(--fix-color-white);
		}
		.icon {
			display: flex;
			flex-basis: 42px;
			aspect-ratio: 1;
			height: 100%;
			padding: 0;
			justify-content: center;
			align-items: center;
			line-height: 0;
			border-left: 1px solid var(--fix-color-border);

			transition: background-color 0.4s ease-out, color 0.4s ease-out;
			background-color: var(--fix-color-white);
			color: var(--fix-color-black);

		}

		button:disabled {
			background-color: var(--fix-color-black);
			border-color: var(--fix-color-border);
			&:hover {
				background-color: var(--fix-color-black);
			}
		}
		button:disabled .label,
		button:disabled .info,
		button:disabled .icon {
			background-color: var(--fix-color-black);
			color: var(--fix-color-disabled-text);
		}

		.progress {
			display: flex;
			flex-direction: row;
			gap: 5px;
			align-items: center;
			margin-left: auto;
			padding-right: var(--padding);
		}
		.dot {
			display:block;
			height: 6px;
			width: 6px;
			background-color: var(--fix-color-incomplete);
			border-radius: 50%;
		}
		.dot.satisfied {
			background-color: var(--fix-color-complete);
			animation: scale 0.3s ease-in;
		}
		.line {
			display:block;
			height: 6px;
			width: 1px;
			margin: 0 2px;
			background-color: var(--fix-color-incomplete);
		}
		@keyframes scale {
			0% {
				transform: scale(2);
			}
			100% {
				transform: scale(1);
			}
		}
	`;

	@property({type: Function})
	action = null;

	@property({type: String})
	label = '';

	@property({type: Array})
	infos = '';

	@property({type: Boolean})
	disabled = false;

	@property({type: String})
	specsheetType = 'family';

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;

		this.spcIsSatisfied = selectSpcIsSatisfied(state);

		this.basicSpcAttributes = selectBasicSpcAttributes(state);
		this.isBasicSatisfied = selectBasicSpcAttributesSatisfied(state);
		this.isDetailSatisfied = selectDetailSpcAttributesSatisfied(state);
		this.detailSpcAttributes = selectDetailSpcAttributes(state);
		this.selectedFamilyConfig = selectFamilyConfig(state);
	}

	render() {
		return html`
			<button class="downloadButton" ?disabled=${this.disabled} @click=${this.action}>
				<div class="buttonLabel">
					<span class="label">${this.label}</span>
					<span class="progress">
						${when((this.specsheetType === 'basic' || this.specsheetType === 'detail') && this.basicSpcAttributes, () => html`
							${repeat(this.basicSpcAttributes, (spcAttribute) => html`
								<span class="dot ${classMap({satisfied: spcAttribute.isSatisfied})}"></span>
							`)}
						`)}
						${when(this.specsheetType === 'detail' && this.detailSpcAttributes, () => html`
							<span class="line"></span>
							${repeat(this.detailSpcAttributes, (spcAttribute) => html`
								<span class="dot ${classMap({satisfied: spcAttribute.isSatisfied})}"></span>
							`)}
						`)}
					</span>
					<span class="icon state ${classMap({satisfied: !this.disabled})}">${next}</span>
				</div>
				<div class="infos">
					${repeat(this.infos, (info) => html`<div class="info">${info}</div>`)}
				</div>
			</button>
		`;
	}
}
